export interface ColumnConfig {
	id: string;
	label: string;
	defaultVisible: boolean;
	width?: string;
	responsiveHide?: 'sm' | 'md' | 'lg';
	truncate?: boolean;
	align?: 'left' | 'center' | 'right';
	sortable: boolean;
}

export const AVAILABLE_COLUMNS: ColumnConfig[] = [
	// Always visible core columns
	{
		id: 'image',
		label: 'Image',
		defaultVisible: true,
		width: 'w-[80px] min-w-[80px]',
		truncate: false,
		align: 'left',
		sortable: false
	},
	{
		id: 'name',
		label: 'Name',
		defaultVisible: true,
		width: 'w-[28%] min-w-[200px]',
		truncate: true,
		align: 'left',
		sortable: true
	},
	{
		id: 'set',
		label: 'Set',
		defaultVisible: true,
		width: 'w-[15%] min-w-[120px]',
		truncate: true,
		align: 'left',
		sortable: true
	},
	{
		id: 'actions',
		label: 'Actions',
		defaultVisible: true,
		width: 'w-[160px] min-w-[160px]',
		truncate: false,
		align: 'center',
		sortable: false
	},
	{
		id: 'price',
		label: 'Price',
		defaultVisible: true,
		width: 'w-[10%] min-w-[90px]',
		truncate: false,
		align: 'center',
		sortable: true
	},
	{
		id: 'cost',
		label: 'Cost',
		defaultVisible: true,
		width: 'w-[8%] min-w-[70px]',
		truncate: false,
		align: 'center',
		sortable: true
	},
	// Toggleable columns
	{
		id: 'rarity',
		label: 'Rarity',
		defaultVisible: false,
		width: 'w-[12%] min-w-[110px]',
		truncate: false,
		align: 'left',
		sortable: true
	}
];
